export default __webpack_public_path__ + "static/media/opsStart.40dfae00.svg";